<template>
    <div class="modal fade" tabindex="-1" role="dialog" id="modalSelectOldNewBom">
        <!-- <div class="modal-backdrop fade" @click="closeModal()"></div> -->
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header border-bottom">
                    <h5 class="modal-title font-weight-bold">Pilih BOM {{typeBom === 'removable' ? 'Lama' : 'Baru'}}</h5>
                    <button type="button" class="close" @click="closeModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body p-3">
                    <div 
                        v-for="(bom, index) in bomData" 
                        :key="index"
                        class="card mb-3 border bom-card"
                        :class="{ 'selected': selectedBOM === bom.id }"
                        @click="setBom(bom)"
                    >
                        <div class="card-body p-3 position-relative">
                            <div class="d-flex justify-content-between align-items-start mb-2">
                                <h6 class="mb-0 font-weight-bold">{{ bom.bomName }}</h6>
                                <!-- <span 
                                    class="badge px-3 py-1"
                                    :class="'badge-' + bom.statusColor"
                                >
                                    {{ bom.status }}
                                </span> -->
                            </div>

                            <div v-for="(comp,i) in bom.itemBom" :key="`itemBom-${i}`">
                                <p v-for="(qty,j) in comp.itemQty" :key="`comp${i}-${j}`" class="mb-1 small">
                                    {{comp.itemName}}
                                </p>
                            </div>

                            <div 
                                v-if="selectedBOM === bom.id"
                                class="position-absolute check-icon"
                                style="right: 15px; top: 50%; transform: translateY(-50%);"
                            >
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3">
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'ModalSelectOldNewBom',
  components : {
   
  },
  props: ['typeBom', 'setSelectedBom', 'bomData'],
    data() {
        return {
            selectedBOM: null,
            bomList: [
                {
                    id: 'BOM-11-004',
                    status: 'Renewable',
                    statusColor: 'success',
                    ram: 'RAM DDR3L SODIMM 8GB',
                    ssd: 'SSD SATA 128GB 2.5INCH',
                    body: 'BODY LENOVO THINKPAD X240 GEN 4 I5'
                },
                {
                    id: 'BOM-11-005',
                    status: 'Onboard',
                    statusColor: 'warning',
                    ram: 'RAM DDR3L SODIMM 8GB',
                    ssd: 'SSD SATA 128GB 2.5INCH',
                    body: 'BODY LENOVO THINKPAD X240 GEN 4 I5'
                },
                {
                    id: 'BOM-11-006',
                    status: 'Onboard',
                    statusColor: 'warning',
                    ram: null,
                    ssd: null,
                    body: null
                }
            ]
        }  
    },
    methods:{
        setBom(bom) {
            this.$emit('selectedBom', bom);
        },
        closeModal() {
            $("#modalSelectOldNewBom").modal("hide")
        },
    },
}

</script>
<style scoped>
.modal-backdrop {
    background-color: rgba(0, 0, 0, 0.5);
}
.bom-card {
    cursor: pointer;
    transition: all 0.2s;
}
.bom-card:hover {
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
.bom-card.selected {
    border-color: #007bff !important;
    border-width: 2px !important;
}
.check-icon {
    width: 24px;
    height: 24px;
    background-color: #007bff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.modal-body {
    max-height: 400px;
    overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/Assembly/CustomComponent/ModalSelectOldNewBom.vue